import type { GalleryItem, GalleryCategory } from '../types/gallery';

/**
 * Branded PLACEHOLDER tiles (public/gallery/g01–g18.webp) matching the reference design. They keep the
 * gallery, filters and lightbox fully functional until real event photography is published through the
 * dashboard's Events module — at which point the live `/public/events` feed takes over (see hooks.ts).
 * Same shape as the live tiles, so nothing downstream needs to branch.
 */
export const galleryCategories: GalleryCategory[] = [
  { slug: 'all', name: 'All' },
  { slug: 'farmer-meetings', name: 'Farmer Meetings' },
  { slug: 'field-demos', name: 'Field Demonstrations' },
  { slug: 'crop-results', name: 'Crop Results' },
  { slug: 'product-launches', name: 'Product Launches' },
  { slug: 'retailer-meetings', name: 'Retailer Meetings' },
  { slug: 'training', name: 'Training' },
  { slug: 'events', name: 'Company Events' },
  { slug: 'field-visits', name: 'Field Visits' },
];

const T = { w: 1000, h: 1300 }; // tall
const S = { w: 1000, h: 800 }; // short

const raw: Array<[string, string, string, string, typeof T | typeof S]> = [
  ['g01', 'farmer-meetings', 'Grower field meet', 'Meeting growers on the ground', T],
  ['g02', 'field-demos', 'Soil biology demo plot', 'Showing the rhizosphere at work', S],
  ['g03', 'product-launches', 'AGN launch event', 'Introducing AGN to the region', T],
  ['g04', 'retailer-meetings', 'Distributor partner meet', 'Building the retailer network', S],
  ['g05', 'training', 'Agronomy training day', 'Crop-specific product training', T],
  ['g06', 'crop-results', 'Grape trial — before & after', 'Field results on grape', S],
  ['g07', 'events', 'Annual grower summit', 'Bringing the community together', T],
  ['g08', 'field-visits', 'Sugarcane crop walk', 'Walking the crop with farmers', S],
  ['g09', 'farmer-meetings', 'Cotton belt outreach', 'On-farm conversations', S],
  ['g10', 'field-demos', 'Foliar spray demonstration', 'Application technique demo', T],
  ['g11', 'crop-results', 'Pomegranate orchard', 'Tracking orchard performance', T],
  ['g12', 'training', 'Retailer product training', 'Deep-diving the range', T],
  ['g13', 'field-demos', 'Drip fertigation trial', 'Fertigation dosing in the field', S],
  ['g14', 'events', 'Team field day', 'Our people in the field', T],
  ['g15', 'farmer-meetings', 'Village grower gathering', 'Community-level engagement', S],
  ['g16', 'crop-results', 'Turmeric harvest', 'Harvest-stage assessment', T],
  ['g17', 'product-launches', 'Nature’s Green 4+ intro', 'Launching foliar strength', S],
  ['g18', 'field-visits', 'Banana plantation visit', 'Plantation crop review', T],
];

export const galleryItems: GalleryItem[] = raw.map(([id, category, title, caption, dim]) => ({
  id,
  src: `/gallery/${id}.webp`,
  width: dim.w,
  height: dim.h,
  category,
  title,
  caption,
  placeholder: true,
}));
